import React from 'react'
import { usePasskey } from './use-passkey'
import { FingerprintIcon } from '../../../icons/Fingerprint'
import { Button } from 'antd'

import "./styles.scss"

export const PasskeyTab = () => {
  const { doAddPasskey, isRegistered, onRemovePasskey } = usePasskey()

  return (
    <div className="passkey-container">
      <p className="passkey-title">Passkey</p>

      {isRegistered && (
        <div
          className="passkey-item"
          style={{ maxWidth: 360, minHeight: 36 }}
        >
          <div className="passkey-item-content">
            <span style={{ fontSize: 0 }}>
              <FingerprintIcon className="passkey-item-icon" />
            </span>
            <span className="passkey-item-title">Touch ID</span>
          </div>

          <span
            onClick={onRemovePasskey}
            className="passkey-item-delete"
          >
            Delete
          </span>
        </div>
      )}
      {!isRegistered && (
        <Button
          className="passkey-add-button"
          onClick={doAddPasskey}
          icon={<FingerprintIcon />}
        >
          Add passkey
        </Button>
      )}
    </div>
  )
}
